<ng-container cdkDrag cdkDragRootElement=".cdk-overlay-pane">
	<div cdkDragHandle class="mep-dialog-header-icon">
		<mat-icon>person_add</mat-icon>
	</div>
	<div class="mep-dialog-title">{{ _lang("header") }}</div>

	<div class="mep-dialog-content" [class.profile-download-content]="showProfileDownloadToggle" mat-dialog-content>
		<div class="mep-text-big">
			<div class="row g-0">
				<div [ngClass]="{'col-12': data.fromProjectAdd, 'col-6': !data.fromProjectAdd}">
					@if (!employeeManuelAdd) {
						<mat-form-field id="employee-input" appearance="outline" class="w-100">
							<mat-label>{{ _lang("inputField") }}</mat-label>
							<div class="input-wrapper">
								<div class="flex-grow">
									<input #autoInput matInput [formControl]="input" [matAutocomplete]="auto" />
								</div>
							</div>
							<mat-progress-bar mode="indeterminate" [hidden]="!loading" class="position-relative"></mat-progress-bar>
							<mat-autocomplete
								#auto
								[displayWith]="displayAsSelectedOption"
								(optionSelected)="onEmployeeSelected($event.option.value)"
								[autoActiveFirstOption]="true"
							>
								@for (option of filteredEmployees | async; track option) {
									<mat-option [value]="option" class="pe-0">
										<div class="option-wrapper">{{ displayAsSelectedOption(option) }}</div>
									</mat-option>
								}
							</mat-autocomplete>
						</mat-form-field>
					}

					@if (employeeManuelAdd) {
						<mat-form-field id="employee-input" appearance="outline" class="w-100">
							<mat-label>{{ _lang("inputFieldAddManual") }}</mat-label>
							<div class="input-wrapper">
								<div class="flex-grow">
									<input #manualInput matInput [formControl]="manuelInput" (keyup.enter)="addManualEmployeeToList()" />
								</div>
							</div>
						</mat-form-field>
					}
				</div>

				@if (!employeeManuelAdd && !data.fromProjectAdd) {
					<div class="col-6 d-flex align-items-center button-column">
						<button
							mat-stroked-button
							color="primary"
							(click)="addManualEmployee()"
							class="w-100 equal-height-btn"
							matTooltip="{{ _lang('tooltipAddManualButton') }}"
						>
							<mat-icon>person_add</mat-icon>
							<mat-label>{{ _lang("addManualButton") }}</mat-label>
						</button>
					</div>
				}

				@if (employeeManuelAdd) {
					<div class="col-6 d-flex align-items-center button-column">
						<button mat-stroked-button color="primary" (click)="addEmployeeWithSearch()" class="w-100 equal-height-btn">
							<mat-label>{{ _lang("addWithNameButton") }}</mat-label>
						</button>
					</div>
				}
			</div>

			@let displayedEmployees = filteredEmployeeByBu(employees);

			@if (showProfileDownloadToggle && displayedEmployees.length > 0) {
				<div class="offered-employees-header">
					<div class="profile-picture-column"></div>
					<div class="employee-name"></div>
					<div class="slider-column-heading">
						<app-news-notification [messageKey]="'profile-download-toggle'" insertDate="14.07.2026">
							{{ _lang("profileDownloadHeading") }}
						</app-news-notification>
					</div>
					@if (allowedToDelete) {
						<div class="close-column"></div>
					}
				</div>
			}

			@for (employee of displayedEmployees; track employee) {
				<div class="mep-list-entry" [ngClass]="{'no-pp': imgFallback}">
					<!--suppress HtmlRequiredAltAttribute -->
					@if (!imgFallback) {
						<img [src]="getProfilePicture(employee)" (error)="imgFallback = true" />
					}
					<div class="employee-name">{{ employee.firstName }} {{ employee.lastName }}</div>
					@if (showProfileDownloadToggle) {
						<div class="slider-column">
							@if (employee.id != null) {
								<div
									[matTooltip]="_lang('tooltipSlideToggle')"
									[class.disabled-cursor]="!canToggleDownload(employee)"
								>
									<mat-slide-toggle
										[disabled]="!canToggleDownload(employee)"
										[checked]="employee.enableDownload === true"
										(change)="onEnableDownloadChange($event, employee)"
									>
									</mat-slide-toggle>
								</div>
							}
						</div>
					}
					@if (allowedToDelete) {
						<div class="entry_close">
							<mat-icon (click)="removeEmployee(employees, employee)">close</mat-icon>
						</div>
					}
				</div>
			}
		</div>
	</div>

	<div class="mep-dialog-actions">
		<button class="mep-btn-dialog-secondary" (click)="dialogRef.close()">
			{{ "mep.components.general.cancel" | translate }}
		</button>
		<button [disabled]="!isSelected" class="mep-btn-dialog-primary" appSaveHotkey (click)="save()">
			{{ "mep.components.general.save" | translate }}
		</button>
	</div>
</ng-container>
